

export enum ObservationTypeEnum {
  car = 1,
  cdi = 2
}

export class ObsType {
  observationTypeId: ObservationTypeEnum;
  observationType: string;
}

//These two are the only allowable values. If more needed, can re-enable the config
export const ObservationTypes: Array<ObsType> = [
  { observationTypeId: ObservationTypeEnum.car, observationType: "CAR" },
  { observationTypeId: ObservationTypeEnum.cdi, observationType: "CDI" }
];

export enum DeficiencyEnum {
  annual = 1,
  critical = 2,
  major = 3,
  minor = 4,
  observation = 5,
  special = 6
}

export enum ObservationCommentTypeEnum{
  correctiveAction = 1,
  managementAction = 2,
  rootCause = 3,
  internalOnly = 4,
  rebuttal = 5
}